import React from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { CookieInfo } from '../QuickQuoteForm/types';
import Toggle from '../Toggle/Toggle';
import styles from './CookieSettings.module.scss';
import { baseURL } from 'common/constants/common';

const CookieSettings = (cookieInfo: CookieInfo) => {
  const {
    cookieGeneralInfo,
    cookieStrictlyNecessary,
    cookiePerformanceTargeting,
    cookieFunctional,
    cookie3rdParty,
    isHidden,
    closeSettings,
    allowedCookies,
    setAllowedCookies,
    onCookieHide,
  } = cookieInfo;

  const options: Record<string, string> = {
    'General Info': cookieGeneralInfo,
    'Strictly Necessary': cookieStrictlyNecessary,
    'Performance & Targeting': cookiePerformanceTargeting,
    Functional: cookieFunctional,
    '3rd Party Testing': cookie3rdParty,
  };

  const cookiesUsedList: Record<string, string[]> = {
    'Strictly Necessary': ['ci_session', 'CookieConsent', '_ga', '_gid', '_gat', '_gcl_au'],
    'Performance & Targeting': ['_hjSession', '_hjIncludedInSessionSample', '_hjSessionUser', '_hjAbsoluteSessionInProgress', 'cebs', 'cebsp', '_ce.clock_data', '_ce.s', '_ce.clock_event', '__Secure-3PAPISID', 'APISID', 'SAPISID', '__Secure-3PSID', '__Secure-1PSID', 'SSID', 'HSID', 'SID', 'NID', 'CONSENT', '__stripe_mid', '__stripe_sid', 'prism',
     'piAId', 'piCId', 'piHostname'
    ],
    'Functional': ['ab_test-bookingButton'],
    '3rd Party Testing': ['optimizelyEndUserId'],
  }

  const [activeSetting, setActiveSetting] = React.useState<string>('General Info');
  const [activeDescription, setActiveDescription] = React.useState<string>(cookieGeneralInfo);

  const onChangeSetting = (setting: string) => {
    setActiveSetting(setting);
    setActiveDescription(options[setting]);
  };

  const updateCookieSettings = (ifAcceptAll: boolean) => {
    if (onCookieHide) {
      onCookieHide(ifAcceptAll);
    }
    window.location.reload();
  };

  return (
    <div className={styles.cookieSettingsContainer} style={{ display: isHidden ? 'none' : '' }}>
      <div className={styles.cookieSettingsHeader}>
        <span>Cookie Settings</span>
        <button
          className={styles.closeButton}
          data-cy="modal-close-button"
          onClick={() => closeSettings(true)}
          type="button"
        >
          <CloseIcon className={styles.closeIcon} />
        </button>
      </div>
      <div className={styles.cookieSettingsList}>
        <ul>
          {Object.keys(options).map((el) => (
            <li
              key={el}
              className={el === activeSetting ? styles.active : ''}
              onClick={() => onChangeSetting(el)}
            >
              {el}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.cookieSettingsContent}>
        <div className={styles.cookieSettingsContentHeader}>
          <h2>
            {activeSetting}
          </h2>
          {activeSetting !== 'General Info' && activeSetting !== 'Strictly Necessary' && <Toggle allowedCookies={allowedCookies} currentSetting={activeSetting} setAllowedCookies={setAllowedCookies} />}
          {activeSetting === 'Strictly Necessary' && <span>Always active</span>}
        </div>
        {activeDescription.split('<br/>').map((line) => <p key={line}>{line}</p>)}
        {activeSetting !== 'General Info' && (
          <div className={styles.cookieSettingsListFull}>
            <strong>Cookies Used</strong>
            {cookiesUsedList[activeSetting].map((cookie: string) => (
              <a key={cookie} href={`${baseURL}privacy-policy#cookies`} target='_blank'>{cookie}</a>
            ))}
          </div>
        )}
        {activeSetting === 'General Info' && (
          <p>
            More information
            <a href={'https://www.coworker.com/privacy-policy'} target={'_blank'}> Privacy and cookie policy</a>
          </p>
        )}
      </div>
      <div className={styles.cookieSettingsButtons}>
        <button className={styles.update} onClick={() => updateCookieSettings(false)} type="button">Update settings</button>
        <button className={styles.accept} onClick={() => updateCookieSettings(true)} type="button">Accept all cookies</button>
      </div>
    </div>
  );
};

export default CookieSettings;
